// 포인트 타입
export type PointHistoryType = 'all' | 'save' | 'use' | 'expire'; // 전체 | 적립 | 사용 | 소멸

// 응모 상태 타입
export type ApplyStatus = 'win' | 'lose' | 'expected' | 'exchange'; // 당첨 | 미당첨 | 발표예정 | 교환

//
export type ApplyType = 'now' | 'exchange';

// 정보 입력 여부 타입
export type InfoYnType = 'Y' | 'N';

// 포인트 메소드 코드 상수
export const POINT_METHOD_CODES = {
  ATTENDANCE: { code: 'attendance', name: '출석체크' },
  CLICK: { code: 'click', name: '원클릭' },
  CARD: { code: 'card', name: '코드입력' },
  ACCOUNT: { code: 'account', name: '회원가입' },
  COLLECTION: { code: 'collection', name: '모으기' },
  OFFLINE: { code: 'offline', name: '오프라인' },
  APPLY: { code: 'apply', name: '응모하기' },
  MINIGAME: { code: 'minigame', name: '미니게임' },
  PRODUCT_REWARD: { code: 'product-reward', name: '구매확정' },
  STICKER_PURCHASE: { code: 'fc_sticker_2025', name: '스티커구매' },
} as const;

// 포인트 메소드 코드 타입 (code 값만 포함)
export type PointMethodCode = (typeof POINT_METHOD_CODES)[keyof typeof POINT_METHOD_CODES]['code'];

// 보유 코튼(포인트) 조회
export interface GetMyPointResponse {
  point: number; // 보유 코튼
  expired_dttm: number; // 소멸 예정 일자(UNIX)
  expired_point: number; // 소멸 예정 코튼
}

// 코튼(포인트) 히스토리 조회
export interface GetPointHistoryRequest {
  page_num: number;
  page_size: number;
  type: PointHistoryType; // 전체 | 적립 | 사용 | 소멸
}

export interface GetPointHistoryItem {
  point_idx: number; // idx
  title: string; // 제목
  method_code: string; // 포인트 유형 (리워드 받기, 게임 참여 등)
  type: Exclude<PointHistoryType, 'all'>; // 적립 | 사용 | 소멸
  point: number; // 포인트
  reg_dttm: number; // 날짜
}

export interface GetPointHistoryResponse {
  count: number;
  rows: GetPointHistoryItem[];
}

// 응모자 정보 미입력 조회
export interface GetApplyNoInfoCountResponse {
  count: number;
}

// 응모내역 조회
export interface GetApplyHistoryRequest {
  page_num: number;
  page_size: number;
}

export interface GetApplyHistoryResponse {
  count: number;
  no_data_count: number;
  rows: {
    hist_idx: number;
    method_title: string;
    product_title: string;
    status: ApplyStatus; // 당첨 | 미당첨 | 발표예정 | 교환
    apply_type: ApplyType;
    end_dttm?: number; // 작성기한
    reg_dttm: number; // UNIX
    info_yn: InfoYnType; // 정보작성 여부
  }[];
}

// 응모내역 상세 조회
export interface GetApplyHistoryDetailRequest {
  hist_idx: number;
}

export interface GetApplyHistoryDetailResponse {
  hist_idx: number;
  apply_type: ApplyType;
  name: string | null;
  phone: string | null;
  birth: string | null;
  post_no: string | null;
  address: string | null;
  address_detail: string | null;
  id_card: string | null;
  privacy_url: string;
  third_party_url: string | null;
  reg_dttm: number;
  collection_info: {
    name: InfoYnType;
    phone: InfoYnType;
    birth: InfoYnType;
    address: InfoYnType;
    id_card: InfoYnType;
  };
}

// 포인트 응모 정보 입력 (Update)
export interface UpdateApplyInfoRequest {
  hist_idx: number;
  name: string;
  phone: string;
  birth?: string;
  post_no?: string;
  address?: string;
  address_detail?: string;
  id_card_file?: File;
}

export interface UpdateApplyInfoResponse {
  result: string;
}

// 데일리 코튼(포인트) 참여 여부 조회
export interface GetDailyAttendanceStatusResponse {
  reg_dttm: number | null; // 마지막 참여시간
  period: number; // 참여 기준 시간
}

// 데일리 코튼(포인트) 참여
export interface PostDailyAttendanceResponse {
  point: number;
}
